<template>
  <div>
    <section-collapseable
      v-if="hasFollowUpSequenceFeature"
      title="Follow Up Sequences"
      :sub-title="followUps.length"
      :class="{'is_in_follow_up': activeFollowUp}"
      :collapseable="!!otherFollowUps.length"
      :button-text="buttonText"
      @add="buttonMethod"
      hide-button-icon
    >
      <p v-if="!followUps.length" class="fus--empty">This contact has never been in a follow up sequence</p>

      <div v-else-if="activeFollowUp">
        <h3 class="active_fus--heading">Contact in active follow up</h3>

        <follow-up-item :follow-up="activeFollowUp"></follow-up-item>
      </div>
      <p v-else-if="!activeFollowUp" class="fus--empty mb-100">There is no active follow up</p>


      <template v-slot:expanded>
        <div v-if="otherFollowUps.length">
          <h4 class="fus--heading">Past Follow Ups</h4>

          <follow-up-item
            v-for="followUp in otherFollowUps"
            :key="followUp.id"
            :follow-up="followUp"
          ></follow-up-item>
        </div>
        <div v-else>
          <p class="fus--empty">This are no past follow up sequences</p>
        </div>
      </template>
    </section-collapseable>

    <section-collapseable
      v-else
      title="Follow Up Sequences"
      default-expanded
    >
      <h4 class="no_follow_up--heading">Upgrade Required</h4>
      <p class="no_follow_up--message">Please <a @click="openBillingPortal">upgrade</a> your subscription in order to get follow up sequences for your leads</p>
    </section-collapseable>

    <!-- Put In Follow Up Modal -->
    <modal-container v-if="hasFollowUpSequenceFeature">
      <modal-crud-form
        ref="putInFollowUpModal"
        title="Follow Up"
        form-component="contact-follow-up-sequence-form"
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
import FollowUpItem from "../../lead/components/FollowUpItem";
import {ENUMS} from "../../../services/enums";

export default {
  name: "ContactFollowUp",
  components: {FollowUpItem},
  computed: {
    hasFollowUpSequenceFeature() {
      return this.$store.getters.account.has_follow_up_sequence_feature;
    },
    activeContact() {
      return this.$store.state.activeContact;
    },
    records() {
      return this.$store.state.activeContact.records;
    },
    primaryRecord() {
      return this.records.find(record => record.id === this.activeContact.contact.primary_record_id);
    },
    followUps() {
      return this.activeContact.followUpSequences;
    },
    otherFollowUps() {
      return this.followUps.filter(followUp => !this.isActiveFollowUp(followUp));
    },
    activeFollowUp() {
      return this.followUps.find(followUp => this.isActiveFollowUp(followUp));
    },
    buttonText() {
      return this.activeFollowUp ? null : "Put In Follow Up Sequence";
    },
  },
  methods: {
    isActiveFollowUp(followUp) {
      const activeStatus = ENUMS.FollowUpSequenceStatusEnum.Active.value;
      const pausedStatus = ENUMS.FollowUpSequenceStatusEnum.Paused.value;

      return followUp.status === activeStatus || followUp.status === pausedStatus;
    },
    buttonMethod() {
      if (!this.activeFollowUp) this.$refs.putInFollowUpModal.open();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.is_in_follow_up {
  border-left: 4px solid $primary;
}

.active_fus {

  &--heading {
    margin-bottom: 3px;
    color: $text-muted;
    font-weight: bold;
    font-size: 0.9rem;
  }

  &--description {
    margin-bottom: 12px;
    color: $text-muted;
    font-size: 0.8rem;
    line-height: 1.3;
  }
}

.fus--heading {
  margin: -0.5rem 0 10px;
}

.fus--empty {
  margin-top: 0.75rem;
  padding: 0 1rem;
  color: $text-muted;
  font-style: italic;
  line-height: 1.3;
}

.no_follow_up {

  &--heading {
    margin:  1rem 0 6px;
    font-size: 1.125rem;
    color: $text-muted;
  }

  &--message {
    color: $text-light;
    line-height: 1.4;
  }
}
</style>
